import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=71e779e8&scoped=true&"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/password.css?vue&type=style&index=0&id=71e779e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e779e8",
  null
  
)

export default component.exports